import React, { useEffect } from "react";
import LineChart from "../../dashboard/chart/LineChart";
import useScaleChart from "./useScaleChart";
import { Divider, Grid, Typography } from "@mui/material";
import { storeScaleChartData } from "app/store/patient/slice/patientSlice";

const ScaleChart = ({ patientId, color, height, isDetailPanel = false }) => {
  const { options, chartData, data, dispatch } = useScaleChart({
    patientId,
    color,
  });

  useEffect(() => {
    if (data) dispatch(storeScaleChartData(data));

    return () => dispatch(storeScaleChartData({}));
  }, [data]);

  return (
    <>
      {data?.data && chartData && (
        <>
          {isDetailPanel && (
            <Divider
              orientation="horizontal"
              variant="middle"
              style={{ height: "1px" }}
            />
          )}
          <Grid
            style={{
              position: "relative",
              display: "flex",
              gap: "10px",
              padding: isDetailPanel ? "20px 16px" : "15px",
              background: color === "dark" ? "#282828" : "transparent",
              color: color === "dark" ? "#fff" : "#333",
            }}
            direction="column"
          >
            <Grid item>
              {isDetailPanel ? (
                <Typography variant="h4" style={{ paddingLeft: "13px" }}>
                  Weight
                </Typography>
              ) : (
                <h2 style={{ fontSize: "18px", marginBottom: "10px" }}>
                  Weight
                </h2>
              )}
            </Grid>
            <Grid item style={{ padding: isDetailPanel ? "15px 0" : 0 }}>
              <div>
                <LineChart
                  options={options}
                  height={height}
                  data={chartData}
                  style={{ cursor: "pointer" }}
                  showDataLabels={true}
                />
              </div>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default ScaleChart;
